// Features/Product-Teachings/Points.ts
class ProductTeachingPoints extends HTMLElement {
  constructor() {
    super();
    const elements = this.querySelectorAll("details");
    const details = Array.from(elements);
    for (const detail of details) {
      const summary = detail.querySelector("summary");
      if (!summary)
        continue;
      summary.addEventListener("click", () => {
        for (const node of details) {
          if (node === detail)
            continue;
          node.removeAttribute("open");
        }
      });
    }
  }
}

// Features/Product-Teachings/Video.ts
class ProductTeachingVideo extends HTMLElement {
  button;
  video;
  constructor() {
    super();
    this.button = this.querySelector("button");
    this.video = this.querySelector("video");
    this.button.addEventListener("click", () => this.toggle(), false);
  }
  hideControls() {
    this.button.style.opacity = String(0);
  }
  showControls() {
    this.button.style.opacity = String(1);
  }
  toggle() {
    if (this.video.paused)
      this.play();
    else
      this.pause();
  }
  pause() {
    this.showControls();
    this.video.pause();
  }
  play() {
    this.hideControls();
    this.video.play();
  }
}

// Features/Product-Teachings/mod.ts
window.customElements.define("product-teachings-points", ProductTeachingPoints);
window.customElements.define("product-teachings-video", ProductTeachingVideo);
